"use client";

import Image from "next/image";
import { Pill } from "./Pill";

export function FloorPlanCard({
  plan,
  type,
  area,
  unitsLeft,
  image,
  onOpen,
}: {
  plan: string;
  type?: string;
  area?: { min: number; max: number };
  unitsLeft?: number;
  image?: string;
  onOpen?: () => void;
}) {
  const areaLabel = area
    ? area.min === area.max
      ? `${area.min.toLocaleString()} sqft`
      : `${area.min.toLocaleString()}-${area.max.toLocaleString()} sqft`
    : "";

  return (
    <button
      type="button"
      onClick={onOpen}
      className="group w-full rounded-2xl border border-line bg-white p-3 text-left transition-shadow hover:shadow-card focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500"
    >
      <div className="relative aspect-square overflow-hidden rounded-xl bg-white">
        {unitsLeft != null && (
          <Pill tone={unitsLeft > 0 ? "avail" : "soldout"} className="absolute left-3 top-3 z-10">
            {unitsLeft > 0 ? `${unitsLeft} ${unitsLeft === 1 ? "unit" : "units"} left` : "Sold out"}
          </Pill>
        )}
        {image ? (
          <Image
            src={image}
            alt={`${plan} floor plan`}
            fill
            unoptimized
            className="object-contain p-5"
            sizes="(min-width: 1024px) 25vw, (min-width: 640px) 50vw, 100vw"
          />
        ) : (
          <div className="flex size-full flex-col items-center justify-center gap-1 bg-surface text-center">
            <span className="font-display text-2xl font-semibold text-ink-faint">{plan}</span>
            <span className="text-xs text-ink-muted">Floor plan not released yet</span>
          </div>
        )}
      </div>
      <div className="px-1 pb-1 pt-4">
        <p className="font-display font-semibold text-ink">{plan}</p>
        {(areaLabel || type) && (
          <p className="mt-1 text-sm text-ink-muted">
            {[areaLabel, type].filter(Boolean).join(" · ")}
          </p>
        )}
      </div>
    </button>
  );
}
